<main class="site-shell">
  <div class="scroll-progress" aria-hidden="true"></div>

  <section class="hero" aria-labelledby="hero-title">
    <div class="hero-content">
      <div
        class="video-shell"
        (pointerenter)="trackPointer($event)"
        (pointermove)="trackPointer($event)"
        (pointerleave)="resetPointer($event)"
      >
        <video
          #heroVideo
          class="hero-video"
          autoplay
          muted
          [muted]="true"
          loop
          playsinline
          preload="auto"
          (loadedmetadata)="ensureVideoPlayback(heroVideo)"
          (canplay)="ensureVideoPlayback(heroVideo)"
        >
          <source
            src="https://karimexclusives.b-cdn.net/sabah/mobile_vipingo_chrome.mp4"
            type="video/mp4"
            media="(max-width: 700px)"
          />
          <source
            src="https://karimexclusives.b-cdn.net/sabah/kling_20260722_VIDEO_Static_cam_5888_0_chrome.mp4"
            type="video/mp4"
          />
        </video>

        <span class="video-shade" aria-hidden="true"></span>
        <div class="brand-cluster">
          <h1 class="brand-lockup" id="hero-title">
            <span class="visually-hidden">Sabah</span>
            <span class="brand-mark" aria-hidden="true"></span>
            <span class="tagline">Vipingo</span>
          </h1>
          <div class="brand-actions">
            <button class="brand-enquire" type="button" (click)="openEnquiry(enquiryDialog)">
              Enquire now
            </button>
          </div>
        </div>
        <span class="video-link" aria-hidden="true">
          <span class="discover-cue">
            <img src="sabah.webp" alt="" />
          </span>
        </span>
        <span class="hero-scroll-cue" aria-hidden="true">
          <span>Scroll</span>
          <i></i>
        </span>
        <div class="hero-wave-ribbon" aria-hidden="true">
          <svg class="hero-wave-art" viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path
              class="hero-wave-art__body"
              d="M-40 84C90 84 155 58 275 58C400 58 455 91 575 91C705 91 760 48 890 48C1020 48 1075 88 1195 88C1310 88 1390 68 1480 72L1480 120L-40 120Z"
            >
              <animate
                attributeName="d"
                dur="5.5s"
                repeatCount="indefinite"
                calcMode="spline"
                keyTimes="0;0.333;0.667;1"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
                values="M-40 84C90 84 155 52 280 52C410 52 460 96 585 96C715 96 765 43 895 43C1025 43 1080 92 1200 92C1320 92 1390 66 1480 70L1480 122L-40 122Z;M-40 75C85 75 165 69 290 67C415 65 475 88 600 88C725 88 780 35 905 35C1035 35 1090 98 1210 98C1325 98 1400 76 1480 78L1480 122L-40 122Z;M-40 94C85 94 145 37 270 38C400 39 450 101 575 101C705 101 760 68 890 68C1020 68 1070 79 1195 79C1320 79 1385 54 1480 58L1480 122L-40 122Z;M-40 84C90 84 155 52 280 52C410 52 460 96 585 96C715 96 765 43 895 43C1025 43 1080 92 1200 92C1320 92 1390 66 1480 70L1480 122L-40 122Z"
              />
            </path>
          </svg>
        </div>
      </div>

      <div class="hero-footer">
        <p class="hero-kicker">Coming soon</p>
        <p class="hero-line">A limited collection.<br />A remarkable setting.</p>
        <button class="hero-cta" type="button" (click)="openEnquiry(enquiryDialog)">
          Register interest
        </button>
        <div class="coastline-marquee" aria-hidden="true">
          <div class="coastline-track"></div>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="contact" aria-labelledby="contact-title">
    <video
      #contactVideo
      class="contact-backdrop"
      autoplay
      muted
      [muted]="true"
      loop
      playsinline
      preload="auto"
      aria-hidden="true"
      (loadedmetadata)="ensureVideoPlayback(contactVideo)"
      (canplay)="ensureVideoPlayback(contactVideo)"
    >
      <source
        src="https://karimexclusives.b-cdn.net/sabah/kling_20260722_VIDEO_PromptA_lo_5587_2_chrome.mp4"
        type="video/mp4"
      />
    </video>
    <span class="contact-shade" aria-hidden="true"></span>
    <div class="contact-content">
      <div class="contact-lockup">
        <h2 class="visually-hidden" id="contact-title">Sabah Vipingo contact information</h2>
        <div class="contact-brand" aria-hidden="true">
          <span class="contact-brand-mark"></span>
          <span>Vipingo</span>
        </div>
        <address>
          <a href="tel:+254140000700">+254 140 000 700</a>
          <a href="mailto:info@karimexclusives.com">info&#64;karimexclusives.com</a>
        </address>
      </div>
      <p class="contact-foot">
        <span>Powered by</span>
        <a
          class="contact-credit-logo"
          href="https://www.karimcgvisuals.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Karim Real Estate"
        >
          <img src="brochure_images/KARIM%20%20LOGO%20(1).webp" alt="" />
          <span class="visually-hidden">Karim Real Estate</span>
        </a>
      </p>
    </div>
  </section>

  <dialog
    #enquiryDialog
    class="enquiry-dialog"
    aria-labelledby="enquiry-title"
    (click)="closeFromBackdrop($event, enquiryDialog)"
  >
    <video
      #enquiryVideo
      class="enquiry-dialog-video"
      autoplay
      muted
      [muted]="true"
      loop
      playsinline
      preload="auto"
      aria-hidden="true"
      (loadedmetadata)="ensureVideoPlayback(enquiryVideo)"
      (canplay)="ensureVideoPlayback(enquiryVideo)"
    >
      <source
        src="https://karimexclusives.b-cdn.net/sabah/kling_20260722_VIDEO_PromptA_lo_5587_2_chrome.mp4"
        type="video/mp4"
      />
    </video>
    <span class="enquiry-dialog-shade" aria-hidden="true"></span>
    <form
      #enquiryForm
      class="enquiry-form"
      (submit)="submitEnquiry(enquiryForm, enquiryDialog); $event.preventDefault()"
    >
      <div class="enquiry-heading">
        <h2 id="enquiry-title">Enquire Today</h2>
        <button
          class="enquiry-close"
          type="button"
          aria-label="Close enquiry form"
          (click)="closeEnquiry(enquiryDialog)"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <p>Fill the form below to register your interest</p>

      <label class="enquiry-field">
        <span class="visually-hidden">Full name</span>
        <input name="fullName" type="text" placeholder="Full name*" autocomplete="name" required />
      </label>
      <label class="enquiry-field">
        <span class="visually-hidden">Email address</span>
        <input
          name="email"
          type="email"
          placeholder="Email address*"
          autocomplete="email"
          required
        />
      </label>
      <label class="enquiry-field">
        <span class="visually-hidden">Phone</span>
        <input name="phone" type="tel" placeholder="Phone*" autocomplete="tel" required />
      </label>
      <label class="enquiry-field">
        <span class="visually-hidden">Apartment type</span>
        <select name="apartmentType" required>
          <option value="" selected disabled>Apartment Type*</option>
          <option value="three-bedroom">3 bedrooms</option>
          <option value="four-bedroom">4 bedrooms</option>
        </select>
      </label>
      <label class="enquiry-field enquiry-field--message">
        <span class="visually-hidden">Message</span>
        <textarea name="message" rows="3" placeholder="Message*" required></textarea>
      </label>

      <label class="enquiry-consent">
        <input name="terms" type="checkbox" required />
        <span>I agree to the terms and conditions</span>
      </label>

      @if (submissionMessage()) {
        <p
          class="enquiry-status"
          [class.enquiry-status--success]="submissionStatus() === 'success'"
          [class.enquiry-status--error]="submissionStatus() === 'error'"
          aria-live="polite"
        >
          {{ submissionMessage() }}
        </p>
      }

      <button
        class="enquiry-submit"
        type="submit"
        [disabled]="submissionStatus() === 'submitting' || submissionStatus() === 'success'"
      >
        @if (submissionStatus() === 'submitting') {
          Sending…
        } @else if (submissionStatus() === 'success') {
          Sent
        } @else {
          Send
        }
      </button>
    </form>
  </dialog>
</main>
